import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { ContextProvider } from "./UserContext";
import Swal from "sweetalert2";
window.Swal = Swal;
const toast = Swal.mixin({
  toast: true,
  position: "top-end",
  timer: 3000,
  timerProgressBar: true,
  showConfirmButton: false,
  icon: "success",
});

const displayToastError = (message = "Something went wrong", timer = 3000) => {
  toast.fire({
    title: message,
    icon: "error",
    timer,
  });
};

window.displayToastError = displayToastError;
window.Toast = toast;

//disabling some shortcuts in production
if (process.env.NODE_ENV === "production") {
  document.onkeydown = function (e) {
    if (e.keyCode === 123) {
      return false;
    }
    if (e.ctrlKey && e.keyCode === "E".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.keyCode === "I".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.shiftKey && e.keyCode === "J".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.keyCode === "U".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.keyCode === "S".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.keyCode === "H".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.keyCode === "A".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.keyCode === "F".charCodeAt(0)) {
      return false;
    }
    if (e.ctrlKey && e.keyCode === "E".charCodeAt(0)) {
      return false;
    }
  };
}

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ContextProvider>
        <App />
      </ContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
